import { CommonDropdownPopperProps, DropdownCustomPopperProps, TextFieldPopperProps } from "../../../molecules/popper"
import { AddressRadioGroupPopperProps } from "../../../molecules/popper/AddressRadioGroupPopper"

export type ShortFormElementPopper =
  | TextFieldPopperProps
  | AddressRadioGroupPopperProps
  | CommonDropdownPopperProps<string>
  | DropdownCustomPopperProps<any>
  | undefined
